import { render, staticRenderFns } from "./compare-file.vue?vue&type=template&id=d56a8b52"
import script from "./compare-file.vue?vue&type=script&lang=js"
export * from "./compare-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports